import { setMyPreferences } from '../apis';
import { getActiveAccountIdentity } from '../auth/clerk';
import {
  clearPendingStromaAppearance,
  getPendingStromaAppearance,
  getStromaAppearance,
  markStromaAppearancePending,
  type StromaAppearance,
} from './ThemeProvider';

function sameAppearance(left: StromaAppearance, right: StromaAppearance): boolean {
  return left.mode === right.mode && left.palette === right.palette && left.typeface === right.typeface;
}

export async function reconcileAppearancePreference(
  accountIdentity: string | null,
  appearance: StromaAppearance,
): Promise<boolean> {
  let candidate = appearance;
  while (accountIdentity === getActiveAccountIdentity()) {
    await setMyPreferences({ appearance: candidate });
    if (accountIdentity !== getActiveAccountIdentity()) return false;
    const latest = getPendingStromaAppearance(accountIdentity) ?? getStromaAppearance(accountIdentity);
    if (sameAppearance(latest, candidate)) {
      clearPendingStromaAppearance(accountIdentity, candidate);
      return true;
    }
    candidate = latest;
    markStromaAppearancePending(accountIdentity, candidate);
  }
  return false;
}
